import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import HeroSection from "./components/sections/HeroSection";
import StatsAndIntegrationsSection from "./components/sections/StatsAndIntegrationsSection";
import FeaturesSection from "./components/sections/FeaturesSection";
import CustomizationSection from "./components/sections/CustomizationSection";
import SupportSection from "./components/sections/SupportSection";
import FAQSection from "./components/sections/FAQSection";
import ContactSection from "./components/sections/ContactSection";

const App: React.FC = () => {
  return (
    <div className="akrbit-app">
      <ScrollToTop />
      <Header />
      <main>
        <HeroSection />
        <StatsAndIntegrationsSection />
        <FeaturesSection />
        <CustomizationSection />
        <SupportSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default App;
